<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Dewan Pengawas
        </li>
        <li class="breadcrumb-item" v-if="can('pegawai-create')">
          <a href="#/dewas-add">Tambah Data</a>
        </li>
      </ol>
    </nav>

    <LogPopupTemplate ref="logPopup" />

    <div class="content-block">
      <h5>
        Daftar Dewan Pengawas
        <span>
          <DxButton
            v-if="can('pegawai-create')"
            icon="plus"
            text="Tambah"
            @click="addDewasBaru"
            styling-mode="outlined"
            type="default"
          />
        </span>
      </h5>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabpanel"
          :data-source="tabSource"
          v-model:selected-index="tabPanelIndex"
          loop="false"
          animation-enabled="true"
          swipe-enabled="false"
          item-title-template="title"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #tDewas>
            <DxDataGrid
              :focused-row-enabled="true"
              :focused-row-index="0"
              ref="refDataGridDewas"
              :data-source="dewasListStore.dataSourceDewasList"
              :allow-column-reordering="true"
              :show-borders="true"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @exporting="onExporting"
              :word-wrap-enabled="true"
              :height="gridHeight"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              @context-menu-preparing="onContextMenuPreparing($event)"
            >
              <DxHeaderFilter :visible="true" />

              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
              />
              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="groupPanel" />
                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('refDataGridDewas')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxColumnFixing :enabled="true" />
              <dx-column
                cell-template="diff-cell-template"
                :fixed="true"
                fixed-position="right"
                :allow-sorting="false"
                data-field="id"
                data-type="number"
                caption="Opsi"
                :allow-exporting="false"
                :allow-edititng="false"
                :allow-filtering="false"
              >
              </dx-column>

              <template #diff-cell-template="{ data }">
                <DxDropDownButton
                  :items="getOptions(data)"
                  icon="menu"
                  :id="data.text"
                  :show-arrow-icon="false"
                  :drop-down-options="{ width: 100 }"
                  @item-click="onItemClick"
                />
              </template>
              <DxColumn
                caption="dewasID"
                data-field="dewas_id"
                data-type="number"
                :visible="false"
              />

              <DxColumn
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                data-field="dewas_nama"
                caption="Nama Dewan Pengawas"
                :fixed="true"
                fixed-position="left"
                :allowHeaderFiltering="false"
                :min-width="200"
              >
              </DxColumn>

              <DxColumn
                dataField="status_aktifs_nama"
                caption="Status Aktif"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusAktifSource }"
              />

              <DxColumn
                data-field="jenis_kelamin"
                caption="L/P"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.jenisKelaminSource }"
              />
              <DxColumn
                data-field="umur"
                caption="Umur"
                data-type="number"
                :allowHeaderFiltering="false"
                :calculate-filter-expression="calculateFilterExpressionUmur"
                :filter-operations="filterOperations"
              />

              <DxColumn
                data-field="tgl_lahir"
                caption="Tgl Lahir"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allowHeaderFiltering="false"
              />
              <DxColumn
                data-field="jabatans_nama"
                caption="Jabatan"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.jabatanDewasSource }"
              />
              <DxColumn
                caption="Dibuat oleh"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
            </DxDataGrid>
          </template>

          <template #tDewasSekre>
            <DxDataGrid
              :focused-row-enabled="true"
              :focused-row-index="0"
              ref="refDataGridDewasSekre"
              :data-source="dewasListStore.dataSourceDewasSekreList"
              :allow-column-reordering="true"
              :show-borders="true"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @exporting="onExporting"
              :word-wrap-enabled="true"
              :height="gridHeight"
              :remote-operations="true"
              :scrolling="{
                mode: 'virtual',
                rowRenderingMode: 'virtual',
                columnRenderingMode: 'virtual',
                useNative: true,
              }"
              @context-menu-preparing="onContextMenuPreparing($event)"
            >
              <DxHeaderFilter :visible="true" />

              <DxScrolling mode="virtual" />
              <DxFilterRow :visible="true" apply-filter="auto" />
              <DxPager
                :visible="true"
                :showPageSizeSelector="false"
                :showNavigationButtons="false"
                :show-info="true"
                :infoText="'Page {0} of {1} ({2} items)'"
              />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />
              <DxEditing
                :allow-updating="false"
                :allow-deleting="false"
                :allow-adding="false"
              />
              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="groupPanel" />
                <DxItem name="addRowButton" show-text="always" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
                <DxItem name="searchPanel" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('refDataGridDewasSekre')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <DxColumnFixing :enabled="true" />
              <dx-column
                cell-template="diff-cell-template"
                :fixed="true"
                fixed-position="right"
                :allow-sorting="false"
                data-field="id"
                data-type="number"
                caption="Opsi"
                :allow-exporting="false"
                :allow-edititng="false"
                :allow-filtering="false"
              >
              </dx-column>

              <template #diff-cell-template="{ data }">
                <DxDropDownButton
                  :items="getOptions(data)"
                  icon="menu"
                  :id="data.text"
                  :show-arrow-icon="false"
                  :drop-down-options="{ width: 100 }"
                  @item-click="onItemClick"
                />
              </template>
              <DxColumn
                caption="dewasID"
                data-field="dewas_id"
                data-type="number"
                :visible="false"
              />

              <DxColumn
                caption="#"
                data-field="row_number"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                data-type="number"
              />

              <DxColumn
                data-field="dewas_nama"
                caption="Nama Dewan Pengawas"
                :fixed="true"
                fixed-position="left"
                :allowHeaderFiltering="false"
                :min-width="200"
              >
              </DxColumn>

              <DxColumn
                dataField="status_aktifs_nama"
                caption="Status Aktif"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.statusAktifSource }"
              />

              <DxColumn
                data-field="jenis_kelamin"
                caption="L/P"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.jenisKelaminSource }"
              />
              <DxColumn
                data-field="umur"
                caption="Umur"
                data-type="number"
                :allowHeaderFiltering="false"
                :calculate-filter-expression="calculateFilterExpressionUmur"
                :filter-operations="filterOperations"
              />

              <DxColumn
                data-field="tgl_lahir"
                caption="Tgl Lahir"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allowHeaderFiltering="false"
              />
              <DxColumn
                data-field="jabatans_nama"
                caption="Jabatan"
                :allowHeaderFiltering="true"
                :header-filter="{ dataSource: commonStore.jabatanDewasSource }"
              />
              <DxColumn
                caption="Dibuat oleh"
                :allowHeaderFiltering="false"
                data-field="created_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />

              <DxColumn
                caption="Diubah oleh"
                :allowHeaderFiltering="false"
                data-field="updated_at_text"
                :allowFiltering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :allow-updating="false"
              />
            </DxDataGrid>
          </template>
        </DxTabPanel>
      </div>
    </div>
  </div>
</template>

<style>
/* Custom styles for selected rows in dxDataGrid */
.focused-grid .dx-datagrid .dx-selection {
  background-color: rgba(119, 199, 231, 0.8) !important; /* Green background */
  color: white !important; /* White text */
}

/* Custom styles for focused rows in dxDataGrid */
.focused-grid .dx-datagrid .dx-row-focused {
  background-color: #2196f3 !important; /* Blue background for focused row */
  color: white !important; /* White text */
}
</style>
<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import { useDewasListStore } from "@/stores/views/dewas-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import { confirm } from "devextreme/ui/dialog";
import can from "@/haspermission";

import DxButton from "devextreme-vue/button";
import { DateTime } from "luxon";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import DxTabPanel from "devextreme-vue/tab-panel";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
  DxButton as DxButtonDatagrid,
  DxSummary,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import DxTextBox from "devextreme-vue/text-box";
import DxDateBox from "devextreme-vue/date-box";

const tabSource = [
  {
    id: 1,
    text: "Dewan Pengawas",
    template: "tDewas",
  },
  {
    id: 2,
    text: "Staf Sekretariat Dewan Pengawas",
    template: "tDewasSekre",
  },
];

/* eslint-disable */
export default {
  components: {
    LogPopupTemplate,
    DxTabPanel,
    confirm,
    DxTextBox,
    DxDateBox,
    DxDataGrid,
    // eslint-disable-next-line
    DxColumn,
    DxPager,
    DxPaging,
    DxEditing,
    DxFilterRow,
    // eslint-disable-next-line
    DxLookup,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxButton,
    DxButtonDatagrid,

    DxPopup,
    DxToolbarItem,
    DxItem,
    DxDropDownButton,

    DxSummary,
    DxTotalItem,
    DxScrolling,
    DxHeaderFilter,
  },
  setup() {
    const dewasListStore = useDewasListStore();

    const commonStore = useCommonStore();

    return {
      dewasListStore,
      commonStore,
    };
  },
  data() {
    const vm = this;
    return {
      logPopupRef: null,
      tabSource: tabSource,
      tabPanelIndex: 0,
      filterOperations: ["=", "<>", ">", "<", "between"],
      filterValue: [],

      stylingMode: "underlined",
      //outlined, filled, underlined
      labelMode: "floating",

      numberingPageSize: 100,
      buttonFilterPintasanVisible: false,

      calculateFilterExpressionUmur: function (
        filterValue,
        selectedFilterOperation,
        target,
      ) {
        var colFilter = "tgl_lahir";
        if (selectedFilterOperation === "=" && target == "filterRow") {
          let filterExpression = [];
          if (filterValue == 0) {
            filterExpression.push([colFilter, "=", null]);
          } else {
            filterExpression.push(
              [colFilter, "<=", vm.calculateDateFromAge(filterValue)],
              "and",
              [
                colFilter,
                ">",
                vm.calculateDateFromAge(parseInt(filterValue) + 1),
              ],
            );
          }
          return filterExpression;
        }

        if (selectedFilterOperation === ">" && target == "filterRow") {
          let filterExpression = [
            colFilter,
            "<",
            vm.calculateDateFromAge(parseInt(filterValue) + 1),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          let filterExpression = [
            colFilter,
            "<>",
            vm.calculateDateFromAge(parseInt(filterValue)),
          ];
          return filterExpression;
        }

        if (selectedFilterOperation === "<" && target == "filterRow") {
          let filterExpression = [
            colFilter,
            ">",
            vm.calculateDateFromAge(filterValue),
          ];
          return filterExpression;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          if (typeof filterValue === "string") {
            let coba = filterValue
              .split(",")
              .map((part) => Number(part.trim()));

            filterValue = coba;
          }
          const minAge = filterValue[0];
          const maxAge = filterValue[1];
          if (minAge !== undefined && maxAge !== undefined) {
            return [
              [colFilter, ">", vm.calculateDateFromAge(parseInt(maxAge) + 1)], // Using '<' to include the exact date of birth
              "and",
              [colFilter, "<", vm.calculateDateFromAge(minAge)],
            ];
          } else if (minAge !== undefined) {
            return [colFilter, "<", vm.calculateDateFromAge(minAge)];
          } else if (maxAge !== undefined) {
            return [
              colFilter,
              ">",
              vm.calculateDateFromAge(parseInt(maxAge) + 1),
            ];
          } else {
            return null; // Return null to indicate that no filter should be applied
          }
        }
      },
    };
  },

  async created() {
    await this.commonStore.preloadStores();
  },

  mounted() {},

  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },

  methods: {
    getOptions(data) {
      return [
        {
          text: "Detail Dewan Pengawas",
          dewas_id: data.data.id,
          row_key: data.key,
        },
        {
          text: "Riwayat Uang Jasa",
          dewas_id: data.data.id,
          row_key: data.key,
        },

        {
          text: "Log Perubahan Data",
          dewas_id: data.data.id,
          row_key: data.key,
        },
        // other options...
      ];
    },
    onContextMenuPreparing(e) {
      if (e.target == "content") {
        e.itemData = {
          dewas_id: e.row.data.id,
          row_key: e.row.data.id,
        };

        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];
        e.items.push({
          text: "Lihat Detail Dewan Pengawas",
          icon: "user",
          onItemClick: () => {
            e.itemData.text = "Detail Dewan Pengawas";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Riwayat Uang Jasa",
          icon: "money",
          onItemClick: () => {
            e.itemData.text = "Riwayat Uang Jasa";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Log Perubahan Data",
          icon: "clock",
          onItemClick: () => {
            e.itemData.text = "Log Perubahan Data";
            this.$refs.logPopup.showAll("dewas", e.row.key);
          },
        });
      }
    },

    onItemClick(e) {
      const dewasId = e.itemData.dewas_id;
      const rowKey = e.itemData.row_key;

      if (e.itemData.text === "Riwayat Uang Jasa") {
        const url = this.$router.resolve({
          name: "gaji-history-custom",
          query: {
            filter: ["dewas_gajis_dewas_id", "=", dewasId],
            is_dewas: true,
          },
        }).href;
        window.open(url, "_blank");
      }

      if (e.itemData.text === "Detail Dewan Pengawas") {
        const url = this.$router.resolve({
          name: "dewas-detail",
          query: { id: dewasId },
        }).href;
        window.open(url, "_blank");
      }
      if (e.itemData.text === "Log Perubahan Data") {
        this.$refs.logPopup.showAll("dewas", rowKey);
      }
    },

    addDewasBaru() {
      this.$router.push({
        name: "dewas-add",
      });
    },
    transformUrlToQuery(filterQueries) {
      const filters = Array.isArray(filterQueries)
        ? filterQueries
        : [filterQueries];

      // Check if 'and' or 'or' exists in filters
      const containsLogicalOperators = filters.some(
        (filter) => filter === "and" || filter === "or",
      );

      if (containsLogicalOperators) {
        // If 'and' or 'or' is found, proceed with transformation
        const transformedFilters = this.transformFilters(filters);

        // Use the transformed filters in your component logic
        return transformedFilters;
      } else {
        // Handle cases where no logical operator is present

        return filterQueries;
      }
    },
    transformFilters(filters) {
      // Initialize an empty array to hold the transformed filters
      const transformedFilters = [];

      // Iterate over the filters to transform them
      filters.forEach((filter) => {
        // Check if the filter is 'and' or 'or'
        if (filter === "and" || filter === "or") {
          transformedFilters.push(filter);
        } else {
          // Split the filter string into its components
          const filterParts = filter.split(",");
          transformedFilters.push(filterParts);
        }
      });

      return transformedFilters;
    },
    refreshDatagrid(gridRef) {
      // this.dewasListStore.dataSourceDewasList.filter(null);

      if (this.$refs[gridRef] && this.$refs[gridRef].instance) {
        // this.$refs[gridRef].instance.clearFilter();
        this.$refs[gridRef].instance.getDataSource().reload();
      }
    },
    calculateDateFromAge(age) {
      const today = DateTime.local();
      return today.minus({ years: age }).toJSDate();
    },
    hilangFilter() {
      this.buttonFilterPintasanVisible = false;
    },

    resetFilter() {
      this.filterValue = [];

      this.$refs["dataGrid"].instance.getDataSource().reload();
    },

    can,

    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Daftar Dewan Pengawas");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar " + this.tabSource[this.tabPanelIndex].text + ".xlsx",
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
